import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel } from '@angular/router';
import { LoginService } from 'src/app/components/auth/service/login.service';
import { BreadcrumbService } from '../../service/breadcrumb.service';
import { NavService } from '../../service/nav.service';
import {BRAND, OTHER_BRAND} from '../../service/organization.services';
import { RsaService } from '../../service/rsa.service';
import { CommonModule } from '@angular/common';  

declare var jQuery: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  routerSubscription;
  public profileClicked = false;
  public notificationClicked = false;
  public languageClicked = false;
  public userName = '';
  public party = '';
  public NO_OF_PI_APPROVAL = 0;
  public NO_OF_ARTWORK_APPROVAL = 0;
  public USER_TYPE;
  public ALLOW_PORTAL_SWITCH: boolean;
  public BRAND = BRAND;
  public OTHER_BRAND = OTHER_BRAND;
  public token: string;
  constructor(
    public router: Router,
    public navServices: NavService,
    public rsaService: RsaService,
    public breadCrumService: BreadcrumbService,
    public loginService: LoginService,
  ) { }
  ngAfterViewInit(): void {
    // throw new Error("Method not implemented.");
    //console.log('AFTER VIEW INIT');

  }

  ngOnInit() {
    // this.navServices.getView();
    //this.recallJsFuntions();
    this.userName = this.rsaService.decrypt(localStorage.getItem('4'));
    this.USER_TYPE = this.rsaService.decrypt(localStorage.getItem('6'));
    this.ALLOW_PORTAL_SWITCH = this.rsaService.decrypt(localStorage.getItem('7')) === 'Y';
    this.token = localStorage.getItem('1');
    if (this.userName) {
      //console.log('NG ON IT');
    } else {
      this.logout();
    }
    this.getNotifications();
  }

  getNotifications() {
    const payload = { email: this.rsaService.decrypt(localStorage.getItem('3')), type: "NOTIFICATION" };
    this.loginService.getIndividualDashboardData(payload).subscribe((data: any) => {
      this.NO_OF_PI_APPROVAL = parseInt(data?.NOTIFICATION?.NOTIFICATION?.NO_OF_PI_APPROVAL ?? 0);
      this.NO_OF_ARTWORK_APPROVAL = parseInt(data?.NOTIFICATION?.NOTIFICATION?.NO_OF_ARTWORK_APPROVAL ?? 0);
    })
  }

  onProfileClick(event) {
    event.preventDefault();
    console.log('PROFILE CLICKED');
    this.profileClicked = !this.profileClicked;
    this.notificationClicked = false;
  }

  onNotificationClick(event) {
    console.log("aaaaa")
    event.preventDefault();
    this.notificationClicked = !this.notificationClicked;
    this.profileClicked = false;
  }
  collapseSidebar() {
    console.log('This.collapse', this.navServices.collapseSidebar);
    this.navServices.collapseSidebar = false;
  }

  toggleSidebar() {
    console.log('This.collapse', this.navServices.collapseSidebar);
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  collapseSecondHeader() {
    console.log('This.collapse', this.navServices.collapseSidebar);
    this.navServices.collapseSecondHeader = !this.navServices.collapseSecondHeader;
  }

  onLangageClick() {
    this.languageClicked = !this.languageClicked;
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['']);
  }

  setParty(value) {

    let a = this.breadCrumService.partyList.filter(f => f.PARTY_NAME === value)
    if (a.length === 1) {
      this.party = a[0].PARTY_ID;

      // this.setLinesList();
    }
    else {
      this.party = '';
    }
  }

  // callHeader(i){
  //   this.navServices.getView(i);
  // }
  confirmParty() {
    this.breadCrumService.onSelectParty(this.party);
  }

  downloadUserManual() {
    this.loginService.downloadAttachment().subscribe(data => {
      var blob = new Blob([data], { type: "application/postscript" });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${BRAND.BRAND_PORTAL_NAME} User Manual.pdf`;
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
  }
}
